<script setup lang="ts">
import { ref } from 'vue';
import { useGroupTypeStore } from '@/store/GroupTypeStore';
import RuleHistoryContent from '@/components/ruleHistory/RuleHistoryContent.vue';
import RuleHistorySearch from '@/components/ruleHistory/RuleHistorySearch.vue';

const groupTypeStore = useGroupTypeStore();

const ruleContentSelected = ref<any>([]);
const groupTypeList = ref<any>([]);

const getGroupTypeData = async () => {
  groupTypeStore.getGroupTypeList().then((response) => {
    if (response.data) {
      groupTypeList.value = response.data;
    }
  });
};
getGroupTypeData();
</script>
<template>
  <div class="card logs-rule-history">
    <div>
      <RuleHistorySearch v-model:ruleContent="ruleContentSelected" />
    </div>
    <div class="view-rule" v-if="ruleContentSelected.value?.length">
      <div>
        <div class="title-rule-history font-bold text-lg mb-3">{{ ruleContentSelected?.label }}</div>
        <div v-for="(rule, index) in ruleContentSelected.value" :key="index">
          <div>
            <RuleHistoryContent :ruleContent="rule" :groupTypes="groupTypeList" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
